import { GzSeverityIconWebComponent } from './component/GzSeverityIconWebComponent';

export { GzSeverityIconWebComponent };
